import { streamGroq, GroqMissingKeyError } from './groq-client';

export async function aiCustomTemplate(channel: 'sms' | 'email', brandVoice: string, onStream: (chunk: string) => void): Promise<void> {
  const system = `You are an SMS/email copywriter for small local businesses. Write a Google review request ${channel}. Use placeholders: {NAME}, {BRAND}, {LINK}, {SIGNATURE}. ${channel === 'sms' ? 'Under 160 chars.' : 'Include subject line.'} Output template body only.`;
  try {
    await streamGroq({
      messages: [{ role: 'system', content: system }, { role: 'user', content: `Brand voice: ${brandVoice}` }],
      temperature: 0.6, onStream,
    });
  } catch (err) {
    if (err instanceof GroqMissingKeyError) { onStream('\n\n⚠️ No Groq API key set. Click the Settings gear ⚙ to add your free key.'); return; }
    onStream(`\n\n⚠️ ${err instanceof Error ? err.message : 'Groq error'}`);
  }
}
